<mat-toolbar class="PatientInfosToolbar" fixed color="primary">
  <ng-container *ngIf="patientUser">
    <mat-icon>face</mat-icon>
    <p
      matTooltip="{{
        (patientUser.patient | getPatientFullName) + (patientUser.patient.pseudoname ? ' (' + patientUser.patient.pseudoname + ')' : '')
      }}"
      matTooltipClass="truncatedNamesTooltip"
    >
      {{
        (patientUser.patient | getPatientFullName) +
          (patientUser.patient.pseudoname
            ? "
            (" +
              patientUser.patient.pseudoname +
              ")"
            : "") | truncate : 30
      }}
    </p>
    <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-venus-mars"></mat-icon>
    <p>
      <span *ngIf="patientUser.patient.gender === 'male' || patientUser.patient.gender === 'female'">
        {{ "choiceLabel.gender." + patientUser.patient.gender | translate }}
      </span>
      <span *ngIf="patientUser.patient.gender !== 'male' && patientUser.patient.gender !== 'female'"> {{ "table.nc" | translate }}</span>
    </p>
    <mat-icon>email</mat-icon>
    <p>{{ getMail(patientUser.patient) }}</p>
    <mat-icon>phone</mat-icon>
    <p>{{ getPhone(patientUser.patient) }}</p>
    <mat-icon *ngIf="getBirthdate(patientUser.patient)">date_range</mat-icon>
    <p>{{ getBirthdate(patientUser.patient) }}</p>
    <h1 *ngIf="getId(patientUser.patient)">#</h1>
    <p *ngIf="getId(patientUser.patient)">{{ getId(patientUser.patient) }}</p>
    <mat-icon *ngIf="patientUser.patient.noSms && patientUser.user.status !== USER_STATUS.ACTIVE && getAuthCode(patientUser.patient)"
      >vpn_key</mat-icon
    >
    <p *ngIf="patientUser.patient.noSms && patientUser.user.status !== USER_STATUS.ACTIVE && getAuthCode(patientUser.patient)">
      {{ getAuthCode(patientUser.patient) }}
    </p>
    <ng-container *ngIf="country === FRANCE && patientUser.patient?.identity?.length">
      <mat-icon>badge</mat-icon>
      <p (click)="showStatusChangeHistoric(patientUser)" style="cursor: pointer" matTooltip="{{ 'btn.history' | translate }}">
        {{ "forms.identityStatus." + (patientUser.patient | getLatestIdentityFromPatient).status | translate }}
      </p>
    </ng-container>
  </ng-container>
  <span class="spacerBetween"></span>
  <ng-container *ngIf="patientUser">
    <ng-container *ngIf="patientUser.patient.active === false && ('patient/historic' | isAuthorized | async) === true">
      <p (click)="openHistoric(patientUser)" style="cursor: pointer" matTooltip="{{ 'btn.history' | translate }}">
        {{
          ("model.patient.disablePatientReason.text" | translate) +
            (deactivationReason ? " (" + (deactivationReason | disabledReasonKey | translate) + ")" : "")
        }}
      </p>
      <p *ngIf="deactivation" class="deactivationBadge" [class.permanent]="isPermanentlyDisabled">
        {{
          (isPermanentlyDisabled ? "model.patient.disablePatientType.badgePermanent" : "model.patient.disablePatientType.badgeTemporary")
            | translate
        }}
      </p>
      <p *ngIf="!isPermanentlyDisabled && deactivation?.predictedEndDate">
        {{ ("model.patient.disablePatientType.until" | translate) + " " + (deactivation.predictedEndDate | safeDate) }}
      </p>
    </ng-container>
    <button
      mat-icon-button
      *ngIf="('dashboard/resetAuthCodeOrPassword' | isAuthorized : 'PUT' | async) === true"
      matTooltip="{{ 'page.patientlist.resetPassword' | translate }}"
      (click)="resetPatientPassword(patientUser)"
      aria-label="icon button with a plus icon"
    >
      <mat-icon>lock_open</mat-icon>
    </button>
    <button
      mat-icon-button
      *ngIf="('dashboard/mfa/disablePatient' | isAuthorized : 'PUT' | async) === true && patientUser.user.mfaActive"
      matTooltip="{{ 'mfa.disable2FA' | translate }}"
      (click)="disablePatient2FA(patientUser)"
      aria-label="icon button with a plus icon"
    >
      <mat-icon>security</mat-icon>
    </button>
    <button mat-icon-button (click)="openPatientHelp()" aria-label="icon button with a ? icon">
      <mat-icon class="customSizeIcon2">help_outline</mat-icon>
    </button>
    <button
      *ngIf="patientUser.patient.active === false && canDeactivate"
      matTooltip=" {{ 'page.patientlist.activatePatientSolo' | translate }}"
      mat-icon-button
      (click)="activatePatient(patientUser.patient)"
      aria-label="icon button with a pencil icon"
    >
      <span class="fa fa-user-check customSizeIcon"></span>
    </button>
    <button
      *ngIf="patientUser.patient.active === true && canDeactivate"
      matTooltip=" {{ 'page.patientlist.disablePatientSolo' | translate }}"
      mat-icon-button
      (click)="disablePatient(patientUser)"
      aria-label="icon button with a slashed user"
    >
      <span class="fa fa-user-slash customSizeIcon"></span>
    </button>
    <span
      *ngIf="isServiceSelected && canUpdate"
      matTooltip="{{ (isPermanentlyDisabled ? 'model.patient.disablePatientType.cannotEdit' : 'btn.update') | translate }}"
    >
      <button mat-icon-button [disabled]="isPermanentlyDisabled" (click)="editPatient()" aria-label="icon button with a plus icon">
        <mat-icon>create</mat-icon>
      </button>
    </span>
    <button
      mat-icon-button
      matTooltip="{{ 'btn.removeForEver' | translate }}"
      class="fail"
      (click)="removeForEver(patientUser.user.caremateIdentifier)"
      *ngIf="isAdmin && ('patient' | isAuthorized : 'DELETE' | async) === true"
      aria-label="icon button with a trash icon"
    >
      <mat-icon>delete_forever</mat-icon>
    </button>
    <button
      mat-icon-button
      matTooltip="{{ 'btn.close' | translate }}"
      (click)="goToPatients()"
      aria-label="icon button with a close icon"
      *ngIf="('/patients' | isAuthorized | async) === true"
    >
      <mat-icon class="fail">close</mat-icon>
    </button>
  </ng-container>
</mat-toolbar>
<div class="PatientInfoExtra" *ngIf="hasPatientInfoExtra">
  <div class="PatientImportantNote" *ngIf="importantNote">
    <mat-icon>warning_amber</mat-icon>
    <span class="label">{{ "page.patient.importantNote" | translate }}</span>
    <span>{{ importantNote }}</span>
  </div>
  <div class="PatientRelatedContacts" *ngIf="relatedContacts.length">
    <mat-icon>group</mat-icon>
    <span class="label">{{ "page.patient.relatedContacts" | translate }}</span>
    <span class="related-contact" *ngFor="let related of relatedContacts">
      <span class="related-name">{{ related.name }}</span>
      <ng-container *ngIf="related.phone">
        <span class="separator">·</span>
        <mat-icon>phone</mat-icon>
        <span>{{ related.phone }}</span>
      </ng-container>
      <ng-container *ngIf="related.mail">
        <span class="separator">·</span>
        <mat-icon>email</mat-icon>
        <span>{{ related.mail }}</span>
      </ng-container>
    </span>
  </div>
</div>
